export default "__VITE_ASSET__KLOd15Ec__"